import { createContext } from 'react';

const formularioDisContext = createContext();

export default formularioDisContext;